import { useCallback, useMemo, useState } from 'react';

interface UseExpandableItemsResult<T> {
  items: T[];
  expanded: boolean;
  canExpand: boolean;
  onToggleExpand: () => void;
}

export function useExpandableItems<T>(
  allItems: T[],
  limit: number
): UseExpandableItemsResult<T> {
  const [expanded, setExpanded] = useState(false);

  const canExpand = allItems.length > limit;

  const items = useMemo(() => {
    if (expanded || !canExpand) return allItems;
    return allItems.slice(0, limit);
  }, [allItems, expanded, canExpand, limit]);

  const onToggleExpand = useCallback(() => {
    setExpanded((prev) => !prev);
  }, []);

  return { items, expanded, canExpand, onToggleExpand };
}
